import { accessRole } from "../../../helpers/access_role";
import ErrorAccess from "../../../components/Error/Content/Access";
import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";

import Index from "./Index/View";
import Create from "./Create/View";
import AddEmployee from "./AddEmployee/View";
import Employee from "./Employee/View";
import CreateRevision from "./CreateRevision/View";
import UpdateGrade from "./UpdateGrade/View";
import UpdatePresence from "./UpdatePresence/View";

const RouteView = (props) => {
  const { params } = props;
  const queryParams = new URLSearchParams(props.location.search);

  const _period_uuid = queryParams.get("period_uuid");
  const _revision_uuid = queryParams.get("revision_uuid");

  const _employee_uuid = queryParams.get("employee_uuid");

  const _create = queryParams.get("create");
  const _addEmployee = queryParams.get("addemployee");
  const _employee = queryParams.get("employee");
  const _create_revision = queryParams.get("create_revision");
  const _update_grade = queryParams.get("update_grade");
  const _update_presence = queryParams.get("update_presence");

  if (_create != null) {
    return accessRole("create") ? <Create /> : <ErrorAccess />;
  }

  if (_employee != null) {
    return accessRole("create") ? <Employee /> : <ErrorAccess />;
  }

  if (_addEmployee != null) {
    return accessRole("create") ? <AddEmployee /> : <ErrorAccess />;
  }

  if (_addEmployee != null) {
    return accessRole("create") ? <AddEmployee /> : <ErrorAccess />;
  }

  if (_create_revision != null) {
    return accessRole("read") ? (
      <CreateRevision
        revision_uuid={_period_uuid}
        employee_uuid={_employee_uuid}
      />
    ) : (
      <ErrorAccess />
    );
  }

  if (_update_grade != null) {
    return accessRole("read") ? (
      <UpdateGrade
        revision_uuid={_revision_uuid}
        employee_uuid={_employee_uuid}
      />
    ) : (
      <ErrorAccess />
    );
  }

  if (_update_presence != null) {
    return accessRole("read") ? (
      <UpdatePresence
        period_uuid={_period_uuid}
        revision_uuid={_revision_uuid}
        employee_uuid={_employee_uuid}
      />
    ) : (
      <ErrorAccess />
    );
  }
  // Jika Admin
  if (accessRole("approve")) {
    return accessRole("read") ? <Index /> : <ErrorAccess />;
  } else {
    return accessRole("read") ? null : <ErrorAccess />;
  }
};

export default RouteView;
